module.exports = __webpack_public_path__ + "eec5d23eecc3d0b66d5e663fa21835f6.png";